import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const SiteInfoCtx = createContext(null);

const FALLBACK = {
  brand_name: "Glitterz SHC",
  logo_url: "",
  website_url: "https://glitterzshc.com",
  announcement: "Complimentary UK delivery on orders over £100 · Hand-finished in London",
  tagline: "Hand-finished fine jewelry, made by craft and worn by character.",
  address_lines: ["Glitterz by SH collections", "Hatton Garden", "London"],
  phone: "+44 20 7405 1234",
  email: "hello@glitterzshc.com",
  hours: "Mon–Sat 10:00–18:00",
  instagram: "", facebook: "", tiktok: "", pinterest: "", twitter: "",
  vat_number: "",
};

export function SiteInfoProvider({ children }) {
  const [info, setInfo] = useState(FALLBACK);

  const refresh = async () => {
    try {
      const { data } = await api.get("/site-info");
      setInfo({ ...FALLBACK, ...data });
    } catch { /* keep fallback */ }
  };

  useEffect(() => { refresh(); }, []);

  const update = async (patch) => {
    const { data } = await api.patch("/admin/site-info", patch);
    setInfo({ ...FALLBACK, ...data });
    return data;
  };

  return <SiteInfoCtx.Provider value={{ info, update, refresh }}>{children}</SiteInfoCtx.Provider>;
}

export const useSiteInfo = () => useContext(SiteInfoCtx) || { info: FALLBACK, update: async () => {}, refresh: async () => {} };
